export default "__VITE_ASSET__CzwZzBJJ__"